export default class GetParameter {
  private param = new Map<string, string>()
  private url = ''

  constructor(url?: string) {
    if (url) {
      this.url = url
    }
  }

  /**
   * 画面遷移する
   */
  public pageTransition(): void {
    const paramString = this.createGetParamString()
    let url = this.url
    if (paramString.length > 0) {
      url = this.url + '?' + paramString
    }
    window.location.href = url
  }

  /**
   * パラメータを取得する
   *
   * 取得できなかった場合、空を返却する
   *
   * @param key パラメータ名
   * @retrun パラメータ値
   */
  public get(key: string): string {
    const value = this.param.get(key)
    if (value) {
      return value
    } else {
      return ''
    }
  }

  /**
   * パラメータをセットする
   * @param key パラメータ名
   * @param value パラメータ値
   */
  public set(key: string, value: string): void {
    if (value.length > 0) {
      value = this.escapeHTMLTag(value)
    }
    this.param.set(key, value)
  }

  /**
   * パラメータが存在するかチェックする
   * @param key パラメータ名
   */
  public hasParamKey(key: string): boolean {
    return this.param.has(key)
  }

  /**
   * セットされているパラメータからGETパラメータ文字列を返却する
   * @param params パラメータ
   */
  public createGetParamString(): string {
    const result: string[] = []
    for (const [key, value] of this.param) {
      result.push(key + '=' + value)
    }
    return result.join('&')
  }

  /**
   * サニタイジング
   * @param str 変換文字列
   */
  private escapeHTMLTag(str: string) {
    const escapeRules: { [s: string]: string } = { '&': '&amp;', '"': '&quot;', '<': '&lt;', '>': '&gt;', "'": '&#39;' }
    return str.replace(/[&"<>]/g, function (c) {
      return escapeRules[c]
    })
  }

  /**
   * サニタイジングをデコード
   * @param str 変換文字列
   */
  private decodeHTMLTag(str: string) {
    return str.replace(/(&amp;|&lt;|&gt;|&quot;)/g, function (c) {
      const decodeRules: { [s: string]: string } = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'" }
      return decodeRules[c]
    })
  }

  /**
  * 現在のページからGETパラメータをセットする
  */
  public setCurrentParam(): void {
    this.url = window.location.href
    const urlSearch = location.search.substr(1).split('&')
    for (let i = 0; i < urlSearch.length; i++) {
      // "&"で分離したパラメータを"="で再分離
      const key = urlSearch[i].split('=')
      if (key[0] && key[1]) {
        this.set(key[0], decodeURIComponent(key[1]))
      }
    }
  }
}
